"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersionedExternalApiDispatcher = void 0;
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
/**
 * Implementation of the InternalApiDispatcher which supports upgrading and downgrading the input
 * internal contract to the version that this module is built against
 *
 * @class VersionedExternalApiDispatcher
 * @implements {InternalApiDispatcher}
 */
class VersionedExternalApiDispatcher {
    /**
     * Creates a new instance of the VersionedExternalApiDispatcher
     * We have multiple version converting dispatchers that work together.
     * If needed, the VersionedExternalApiDispatcher wraps either the InternalApiDispatcher (desktop)
     * or the CrossFrameDispatcher (server).
     * The Internal/CrossFrame dispatchers handle an updated platform with an older external library.
     * (The CrossFrameDispatcher sends messages across the frame, and it is handled by the PresLayerHandler.)
     * Meanwhile, the VersionedExternalApiDispatcher handles an updated external library with an older platform.
  
     * @param _apiDelegateDispatcher The delegate that does the actual work.
     * @param platformVersionNumber The version of the internal contract which the platform module is using.
     * This number will be used to figure out how to downgrade incoming commands and upgrade the results
     */
    constructor(_apiDelegateDispatcher, platformVersionNumber) {
        this._apiDelegateDispatcher = _apiDelegateDispatcher;
        this._versionConverter = (0, api_internal_contract_js_1.CreateExternalCompatibleVersionConverter)(api_internal_contract_js_1.INTERNAL_CONTRACT_VERSION, platformVersionNumber);
        this._notificationHandlers = [];
        _apiDelegateDispatcher.registerNotificationHandler((notification) => {
            if (this._notificationHandlers.length === 0) {
                return;
            }
            const upgradedNotification = this._versionConverter.upgradeNotification(notification);
            this._notificationHandlers.forEach((handler) => {
                handler(upgradedNotification);
            });
        });
    }
    static needsVersionConverter(platformVersion) {
        // If our platform is less than external library version, then we need a converter
        return (0, api_internal_contract_js_1.VersionLessThan)(platformVersion, api_internal_contract_js_1.INTERNAL_CONTRACT_VERSION);
    }
    execute(verb, parameters) {
        try {
            const downgradeParameters = this._versionConverter.downgradeExecuteCall(verb, parameters);
            return this._apiDelegateDispatcher.execute(downgradeParameters.verb, downgradeParameters.parameters).then((response) => {
                const upgradeResponse = this._versionConverter.upgradeExecuteReturn(response, verb, parameters);
                return upgradeResponse;
            });
        }
        catch (e) {
            return Promise.reject(e);
        }
    }
    registerNotificationHandler(handler) {
        this._notificationHandlers.push(handler);
    }
    unregisterNotificationHandler(handler) {
        this._notificationHandlers = this._notificationHandlers.filter((h) => h !== handler);
    }
}
exports.VersionedExternalApiDispatcher = VersionedExternalApiDispatcher;
//# sourceMappingURL=VersionedExternalApiDispatcher.js.map